import { styled } from '@mui/material/styles';
import { alpha } from '@mui/material';

import { BadgeTextContainer } from 'pages/document/page/components/StyledComponents';

export const PaymentInProgressTextContainer = styled(BadgeTextContainer, {
  label: 'PaymentInProgressBadge',
  shouldForwardProp: (propName) => !['fontSize'].includes(propName),
})(({ theme }) => ({
  backgroundColor: alpha(theme.palette.primary.main, 0.5),
  color: theme.palette.primary.dark,
}));
